/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import doctorSvg from '../../../public/doctor-circle.svg';
class MyCenters extends React.Component {
  render() {
    return (
      <div className="container pt-2">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="#">Home</Link></li>
            <li className="breadcrumb-item active" aria-current="page">My Centers</li>
          </ol>
        </nav>
        <div className="row bg-dark-subtle p-2 mt-5 mb-3 rounded rounded-2">
          <div className="col-md-10 head-title">
            <h4>My Centers, <span className="linear-title">Ayush Australia</span></h4>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus
            </p>
          </div>
          <div className="col-md-2 d-flex align-items-center justify-content-center">
            <button type="button" className="btn theme-btn-outline">
              <i className="fa fa-plus-circle" aria-hidden="true"></i> Add New
            </button>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12 mb-4">
            <div className="fw-normal show-count">Showing 8 of 10 results...</div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="card p-3 clinic-card imp-clinic-bg-border">
              <div className="row">
                <div className="col-md-1">
                  <img src={doctorSvg} className="mt-3" alt="centers and services" />
                </div>
                <div className="col-md-11">
                  <div className="card-body">
                    <h5 className="card-title fs-5 fw-bold">Dr Vivek’s Naturopathy clinic
                      <span className="badge text-bg-light float-end fw-normal p-3 px-4 rounded rounded-5">15 Products</span></h5>
                    <p className="card-text">
                      <small className="text-muted"><i className="fa fa-map-marker" aria-hidden="true" /> Sydney </small>
                    </p>
                    <p className="card-text"><b>Services</b> - Yoga Therapy, Naturopathy therapy, Stress Reduction</p>
                    <p className="card-text">
                      <Link to="#" className="card-link fw-bold">View/ Edit Details</Link> | <Link to="#" className="card-link fw-bold">View Products</Link></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="card p-3 clinic-card imp-clinic-bg-border">
              <div className="row">
                <div className="col-md-1">
                  <img src={doctorSvg} className="mt-3" alt="centers and services" />
                </div>
                <div className="col-md-11">
                  <div className="card-body">
                    <h5 className="card-title fs-5 fw-bold">Dr Vivek’s Naturopathy clinic
                      <span className="badge text-bg-light float-end fw-normal p-3 px-4 rounded rounded-5">15 Products</span></h5>
                    <p className="card-text">
                      <small className="text-muted"><i className="fa fa-map-marker" aria-hidden="true" /> Sydney </small>
                    </p>
                    <p className="card-text"><b>Services</b> - Yoga Therapy, Naturopathy therapy, Stress Reduction</p>
                    <p className="card-text">
                      <Link to="#" className="card-link fw-bold">View/ Edit Details</Link> | <Link to="#" className="card-link fw-bold">View Products</Link></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="card p-3 clinic-card">
              <div className="row">
                <div className="col-md-1">
                  <img src={doctorSvg} className="mt-3" alt="centers and services" />
                </div>
                <div className="col-md-11">
                  <div className="card-body">
                    <h5 className="card-title fs-5 fw-bold">Dr Vivek’s Naturopathy clinic
                      <span className="badge text-bg-light float-end fw-normal p-3 px-4 rounded rounded-5">15 Products</span></h5>
                    <p className="card-text">
                      <small className="text-muted"><i className="fa fa-map-marker" aria-hidden="true" /> Sydney </small>
                    </p>
                    <p className="card-text"><b>Services</b> - Yoga Therapy, Naturopathy therapy, Stress Reduction</p>
                    <p className="card-text">
                      <Link to="#" className="card-link fw-bold">View/ Edit Details</Link> | <Link to="#" className="card-link fw-bold">View Products</Link></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="card p-3 clinic-card">
              <div className="row">
                <div className="col-md-1">
                  <img src={doctorSvg} className="mt-3" alt="centers and services" />
                </div>
                <div className="col-md-11">
                  <div className="card-body">
                    <h5 className="card-title fs-5 fw-bold">Dr Vivek’s Naturopathy clinic
                      <span className="badge text-bg-light float-end fw-normal p-3 px-4 rounded rounded-5">15 Products</span></h5>
                    <p className="card-text">
                      <small className="text-muted"><i className="fa fa-map-marker" aria-hidden="true" /> Sydney </small>
                    </p>
                    <p className="card-text"><b>Services</b> - Yoga Therapy, Naturopathy therapy, Stress Reduction</p>
                    <p className="card-text">
                      <Link to="#" className="card-link fw-bold">View/ Edit Details</Link> | <Link to="#" className="card-link fw-bold">View Products</Link></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="card p-3 clinic-card imp-clinic-bg-border">
              <div className="row">
                <div className="col-md-1">
                  <img src={doctorSvg} className="mt-3" alt="centers and services" />
                </div>
                <div className="col-md-11">
                  <div className="card-body">
                    <h5 className="card-title fs-5 fw-bold">Dr Vivek’s Naturopathy clinic
                      <span className="badge text-bg-light float-end fw-normal p-3 px-4 rounded rounded-5">15 Products</span></h5>
                    <p className="card-text">
                      <small className="text-muted"><i className="fa fa-map-marker" aria-hidden="true" /> Sydney </small>
                    </p>
                    <p className="card-text"><b>Services</b> - Yoga Therapy, Naturopathy therapy, Stress Reduction</p>
                    <p className="card-text">
                      <Link to="#" className="card-link fw-bold">View/ Edit Details</Link> | <Link to="#" className="card-link fw-bold">View Products</Link></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="card p-3 clinic-card imp-clinic-bg-border">
              <div className="row">
                <div className="col-md-1">
                  <img src={doctorSvg} className="mt-3" alt="centers and services" />
                </div>
                <div className="col-md-11">
                  <div className="card-body">
                    <h5 className="card-title fs-5 fw-bold">Dr Vivek’s Naturopathy clinic
                      <span className="badge text-bg-light float-end fw-normal p-3 px-4 rounded rounded-5">15 Products</span></h5>
                    <p className="card-text">
                      <small className="text-muted"><i className="fa fa-map-marker" aria-hidden="true" /> Sydney </small>
                    </p>
                    <p className="card-text"><b>Services</b> - Yoga Therapy, Naturopathy therapy, Stress Reduction</p>
                    <p className="card-text">
                      <Link to="#" className="card-link fw-bold">View/ Edit Details</Link> | <Link to="#" className="card-link fw-bold">View Products</Link></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="card p-3 clinic-card">
              <div className="row">
                <div className="col-md-1">
                  <img src={doctorSvg} className="mt-3" alt="centers and services" />
                </div>
                <div className="col-md-11">
                  <div className="card-body">
                    <h5 className="card-title fs-5 fw-bold">Dr Vivek’s Naturopathy clinic
                      <span className="badge text-bg-light float-end fw-normal p-3 px-4 rounded rounded-5">15 Products</span></h5>
                    <p className="card-text">
                      <small className="text-muted"><i className="fa fa-map-marker" aria-hidden="true" /> Sydney </small>
                    </p>
                    <p className="card-text"><b>Services</b> - Yoga Therapy, Naturopathy therapy, Stress Reduction</p>
                    <p className="card-text">
                      <Link to="#" className="card-link fw-bold">View/ Edit Details</Link> | <Link to="#" className="card-link fw-bold">View Products</Link></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="card p-3 clinic-card">
              <div className="row">
                <div className="col-md-1">
                  <img src={doctorSvg} className="mt-3" alt="centers and services" />
                </div>
                <div className="col-md-11">
                  <div className="card-body">
                    <h5 className="card-title fs-5 fw-bold">Dr Vivek’s Naturopathy clinic
                      <span className="badge text-bg-light float-end fw-normal p-3 px-4 rounded rounded-5">15 Products</span></h5>
                    <p className="card-text">
                      <small className="text-muted"><i className="fa fa-map-marker" aria-hidden="true" /> Sydney </small>
                    </p>
                    <p className="card-text"><b>Services</b> - Yoga Therapy, Naturopathy therapy, Stress Reduction</p>
                    <p className="card-text">
                      <Link to="#" className="card-link fw-bold">View/ Edit Details</Link> | <Link to="#" className="card-link fw-bold">View Products</Link></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default MyCenters;